export default __webpack_public_path__ + "static/media/checkmark.56e83bad.svg";